import React, { Component } from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import Button from "../../components/Button";


class VTest1 extends Component {

constructor(props) {
    super(props);

this.handleClick = this.handleClick.bind(this)
	
}

handleClick(){this.props.testTaskUserId(["Test01", "/Test2"]);
	}

render() {
    return (
	<div> 
		
		<InstructionContainer>
			<h1> Test </h1>
			
			<InstructionContainer>
			<P>
				The test consists of three tasks. 
				<br/> You should answer ALL the tasks.
				<br/> You are evaluated on how well your image matches to the target image.  
				<br/> Upon completion of the test, you will get a token.
				This token is your answer to the qualification test in the MTurk interface.
				
				<br/><br/>Do NOT refresh the browser at any stage until you complete the test. 
				If the browser was refreshed take the test again from the beginning. 
				<br/>Do NOT go back with the browser during the test. 
				
			</P>
		</InstructionContainer>
						
			<h2> Click the button to start the test </h2>
			
		</InstructionContainer>
				
		
		<StyledButton onClick={this.handleClick}>
			<RedirectLink to="/align">Test #1</RedirectLink>
		</StyledButton>
		
	</div>
	);
	}
}
export default VTest1;



// justify-content: center;
// align-items: center;
// display: column;

// layout
const InstructionContainer = styled.div`
background: lightblue;
margin: 1em;
width: 90vw;


 ${props => props.primary && css `  //that's for displaying app component
    background: #e0e0e0;
	max-width: 60vw;
	margin: auto;
  `}

`;
 
const P = styled.p`
text-align: left;
font-size: large;

	${props => props.primary && css `  //that's for displaying app component
    font-size: small;
	`}

`;

const InstructionImage = styled.img`
overflow: scroll;
width: 90vw;
margin: 1em;

`;

const StyledButton = styled(Button)`
  width: 10%;
  margin-left: 45%;
`;

const RedirectLink = styled(Link)`
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0);
  padding: 20px 10px;
  border-radius: 4px;
  text-decoration: none;
  color: inherit;
  transition: all 300ms;
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;
